<template>
    <div class="mx-auto col-lg-6 col-md-8 col-sm-12 header-margin">
        <div class="text-center p-2">
            <h3>{{ $t('topPage.title') }}</h3>
        </div>

        <div class="list">
            <div>{{ $t('topPage.menu.education.title')}}</div>
            <ul>
                <li>
                    <router-link class="nav-link" to="/">
                        {{ $t('topPage.menu.education.link') }}
                    </router-link>
                </li>
            </ul>

            <div>{{ $t('topPage.menu.wallet.title') }}</div>
            <ul>
                <li>
                    <router-link class="nav-link" to="/balance">
                        {{ $t('balance.link') }}
                    </router-link>
                </li>
            </ul>
        </div>

    </div>
</template>

<script>
    export default {
        name: 'top-page',

        data() {
            return {}
        }
    }
</script>
